const INTERRUPTED_SHOWN_KEY = 'meetingInterruptedShown'

export function hasInviteeWithPhone (meeting) {
  if (!meeting || meeting === false) {
    return false
  }
  const participants = meeting.participants
  if (!Array.isArray(participants)) {
    return false
  }
  const invitee = participants[1]
  if (invitee && typeof invitee.phone === 'string' && invitee.phone.trim() !== '') {
    return true
  }
  return participants.some(participant =>
    participant &&
    typeof participant.user === 'undefined' &&
    typeof participant.phone === 'string' &&
    participant.phone.trim() !== ''
  )
}

export function hasPendingDirectAgentMeeting (getters) {
  if (getters.getMeetingEnded || getters.getMeetingInterrupted || getters.getMeetingStarted) {
    return false
  }
  return hasInviteeWithPhone(getters.getMeeting)
}

export function isForcedAgentInterrupt (getters, isForcedDisconnect) {
  return isForcedDisconnect === true &&
    getters.getUser !== false &&
    getters.isDirectOrMeek
}

export function buildAgentLastMeetingInfo (meeting, user) {
  if (!meeting || meeting === false || !user || user === false) {
    return {}
  }

  const lastMeetingInfo = {
    id: meeting.id,
    is_appointment: meeting.is_appointment
  }

  if (meeting.company) {
    lastMeetingInfo.company = {
      features: meeting.company.features || []
    }
  }

  const agentParticipant = Array.isArray(meeting.participants)
    ? meeting.participants.find(participant => participant && typeof participant.user !== 'undefined' && participant.user === user.id)
    : null

  if (agentParticipant) {
    lastMeetingInfo.participant = agentParticipant.id
    lastMeetingInfo.participantName = agentParticipant.name
    lastMeetingInfo.user = user.id
  }

  const invitee = Array.isArray(meeting.participants)
    ? meeting.participants.find(participant => participant && typeof participant.user === 'undefined')
    : null
  if (invitee && invitee.name) {
    lastMeetingInfo.inviteeName = invitee.name
  }

  return lastMeetingInfo
}

export function clearEndedMeetingState (store) {
  store.commit('setMeetingInterrupted', false)
  store.commit('setMeetingEnded', false)
  store.commit('setMeetingEndedAs', null)
}

export function clearInterruptedSession (store) {
  clearInterruptedShownFlag()
  clearEndedMeetingState(store)
}

export function clearInterruptedShownFlag () {
  try {
    sessionStorage.removeItem(INTERRUPTED_SHOWN_KEY)
  } catch (e) {}
}

export function wasInterruptedShown () {
  try {
    return sessionStorage.getItem(INTERRUPTED_SHOWN_KEY) === 'true'
  } catch (e) {
    return false
  }
}

export function markInterruptedShown () {
  try {
    sessionStorage.setItem(INTERRUPTED_SHOWN_KEY, 'true')
  } catch (e) {}
}
